export const updateCroppingRatio = (value) => ({
  type: "UPDATE_CROPPING_RATIO",
  value,
});
